import { render, staticRenderFns } from "./CnicBackPreviewPopup.vue?vue&type=template&id=7d90cea0&"
import script from "./CnicBackPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./CnicBackPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports